import FormatClear from '@mui/icons-material/FormatClear';
import { ToggleButton } from '@mui/material';
import {
  AlignmentButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  RichTextInputToolbar,
  useTiptapEditor,
} from 'ra-input-rich-text';

import { CustomFormatButtons } from './CustomFormatButtons';

interface CustomRichTextToolbarProps {
  size: 'small' | 'medium' | 'large';
}

export const CustomRichTextToolbar = ({ size }: CustomRichTextToolbarProps) => {
  const editor = useTiptapEditor();

  return (
    <div style={{ alignSelf: 'flex-start' }}>
      <RichTextInputToolbar>
        <LevelSelect size={size} />
        <CustomFormatButtons size={size} />
        <AlignmentButtons size={size} />
        <ListButtons size={size} />
        <LinkButtons size={size} />
        <ToggleButton
          aria-label="Remove format"
          title="Remove format"
          value="clear"
          size={size}
          onClick={() => {
            editor.chain().focus().setParagraph().run();
            editor.chain().focus().unsetAllMarks().run();
          }}>
          <FormatClear fontSize="inherit" />
        </ToggleButton>
      </RichTextInputToolbar>
    </div>
  );
};
